import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useUser } from "./UserContext";

/**
 * Route guard that only renders children for Admin or SystemAdmin users.
 * Regular users are redirected to Home.
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, isProfileLoading, profile } = useUser();

  if (isProfileLoading || profile == null) return null;

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
